import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  as?: 'div' | 'li';
};
export function Reveal({
  children,
  className = '',
  delay = 0,
  as = 'div'
}: RevealProps) {
  const reduceMotion = useReducedMotion();
  if (reduceMotion) {
    const Tag = as;
    return <Tag className={className} data-id="element-157" data-mp="3gitkkjrzq985">{children}</Tag>;
  }
  const MotionTag = as === 'li' ? motion.li : motion.div;
  return <MotionTag className={className} initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.2
  }} transition={{
    duration: 0.28,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-158" data-mp="2ns1t1zlve8r5">
      {children}
    </MotionTag>;
}